// extracted by mini-css-extract-plugin
export default {"component":"styles_component__q1+aS","list":"styles_list__HE7Kj","listItem":"styles_listItem__adbY8"};